// src/Demos/ArithmeticGeometricDemo.js

import React from "react";
import CoordinatePlane from "../MathTools/CoordinatePlane";

/**
 * ArithmeticGeometricDemo
 * 
 * Props:
 *   maxN: number (default 6) — how many terms to plot
 *   width, height: number — optional props for customizing the CoordinatePlane size
 *   disablePlot: boolean (default false) — whether to disable user-click plotting
 */
export default function ArithmeticGeometricDemo({
  maxN = 6,
  width = 400,
  height = 300,
  disablePlot = false
}) {
  // Build lines array
  const lines = [];
  for (let n = 1; n <= maxN; n++) {
    const xVal = n;
    const yVal = n * Math.pow(2, n);
    lines.push({
      start: [xVal, yVal],
      end: [xVal, yVal],
      color: "blue",
      label: `Term #${n}`
    });
  }

  return (
    <div style={{ margin: "1em 0" }}>
      <h5>Arithmetic–Geometric Sequence Demo</h5>
      <CoordinatePlane
        width={width}
        height={height}
        showAxes={true}
        lines={lines}
        style={{ margin: "0 auto", display: "block" }}

        // Pass the disablePlot prop on to the plane:
        disablePlot={disablePlot}
      />
      <p style={{ fontSize: "0.9em", textAlign: "center" }}>
        The points (n, n·2<sup>n</sup>) for n=1..{maxN}
      </p>
    </div>
  );
}
